var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIframe2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.189,
    height: 12.189,
    viewBox: "0 0 12.189 12.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 12.189,
    height: 12.189,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M5.922,4.808l.108.109h0l.572.572a2.375,2.375,0,0,0,.26-.919,2.1,2.1,0,0,0-.108-.83A1.908,1.908,0,0,0,6.3,3.015L3.853.567A1.9,1.9,0,0,0,3.128.114,2.163,2.163,0,0,0,1.878.073,2.513,2.513,0,0,0,.734.733,2.46,2.46,0,0,0,.005,2.3a2.1,2.1,0,0,0,.108.83,1.9,1.9,0,0,0,.454.725L3.015,6.3a1.915,1.915,0,0,0,.725.454,2.167,2.167,0,0,0,1.25.04,2.41,2.41,0,0,0,.5-.191l-.573-.572h0l-.108-.107a1.426,1.426,0,0,1-.3.054,1.207,1.207,0,0,1-.479-.061,1.015,1.015,0,0,1-.389-.243L1.195,3.225a1.015,1.015,0,0,1-.243-.389A1.277,1.277,0,0,1,.933,2.1a1.619,1.619,0,0,1,.429-.738,1.571,1.571,0,0,1,1-.471,1.207,1.207,0,0,1,.479.061,1.019,1.019,0,0,1,.389.243L5.673,3.642a1.017,1.017,0,0,1,.243.389,1.28,1.28,0,0,1,.019.736c0,.013-.009.026-.013.04",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M22.843,23.956l-.681-.681a2.375,2.375,0,0,0-.26.919,2.1,2.1,0,0,0,.108.83,1.907,1.907,0,0,0,.454.725L24.911,28.2a1.9,1.9,0,0,0,.725.454,2.164,2.164,0,0,0,1.249.041,2.51,2.51,0,0,0,1.145-.661,2.461,2.461,0,0,0,.728-1.565,2.1,2.1,0,0,0-.109-.83,1.9,1.9,0,0,0-.454-.725l-2.448-2.448a1.911,1.911,0,0,0-.725-.454,2.167,2.167,0,0,0-1.25-.041,2.426,2.426,0,0,0-.5.191l.681.681a1.434,1.434,0,0,1,.3-.054,1.217,1.217,0,0,1,.479.061,1.021,1.021,0,0,1,.389.243l2.448,2.448a1.022,1.022,0,0,1,.243.389,1.28,1.28,0,0,1,.019.737,1.617,1.617,0,0,1-.428.738,1.578,1.578,0,0,1-1,.471,1.207,1.207,0,0,1-.479-.061,1.018,1.018,0,0,1-.389-.243l-2.448-2.448a1.017,1.017,0,0,1-.243-.389A1.282,1.282,0,0,1,22.829,24c0-.013.01-.026.013-.04",
    transform: "translate(-16.575 -16.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M16.1,14.983l-.1-.1-.571-.572h0l-.109-.109-1.571-1.571a.751.751,0,0,0-1.06,0l-.053.053a.751.751,0,0,0,0,1.06L14.2,15.319l.107.107h0l.573.572.1.1.681.681,1.195,1.195a.749.749,0,0,0,1.06,0l.053-.053a.75.75,0,0,0,0-1.061l-1.2-1.2Z",
    transform: "translate(-9.396 -9.397)",
    fill: "#f5010d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIframe2);
export default __webpack_public_path__ + "static/media/Iframe-2.ae283adf9eff5f5baeb660ebddb4885c.svg";
export { ForwardRef as ReactComponent };